import gql from 'graphql-tag';

import type { EntityComplianceData } from 'src/data/compliance';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryComplianceForLongFormDraftArgs } from 'src/types/backend';

import { FRAGMENT_LONG_FORM_DRAFT_COMPLIANCE } from './schema';

const QUERY = gql`
  query ComplianceForLongFormDraft($id: ID!) {
    complianceForLongFormDraft(id: $id) {
      ...LongFormDraftCompliance
    }
  }
  ${FRAGMENT_LONG_FORM_DRAFT_COMPLIANCE}
`;

type Variables = BackendQueryComplianceForLongFormDraftArgs;
type Result = EntityComplianceData;

export const queryComplianceForLongFormDraft = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
